import React from 'react';
import PopoverMenuItem from "../../../../core/gd-components/popover-menu/popover-menu/menu-item";

type Props = {
    menuParams : any,
    hidePopover: ()=>void
}

function MoreMenu(props: Props) {

    const onRename = () => {props.menuParams.onRename(); props.hidePopover();}
    const onLeave = () => {props.menuParams.onLeave(); props.hidePopover();}
    const onDelete = () => {props.menuParams.onDelete(); props.hidePopover();}

    return (
        <div className="ui5-popover-menu">
            {props.menuParams.chatType !== 1 && (<PopoverMenuItem icon="ico i5-pen"       label="Rename"   onClick={onRename}/>)}
            <PopoverMenuItem icon="ico i5-clock-out"                                label="Leave"    onClick={onLeave}/>
            {props.menuParams.chatType !== 1 && (<PopoverMenuItem icon="ico i5-trash-alt" label="Delete"   onClick={onDelete}/>)}

        </div>
    );
}

export default MoreMenu;